import { AttachFile } from "@mui/icons-material";
import { Button, Grid, IconButton } from "@mui/material";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import ComplainMessage from "../../../components/common/complainMessage";
import { TrashIcon } from "../../../assets/icons";

function ComplainMessages({ model, onUpdate, onSendMessage, onMessageDelete }) {
    const { t } = useTranslation('ComplainDetailsScreen', { keyPrefix: 'Messages' });
    const [newMessage, setNewMessage] = useState("");
    const [attachments, setAttachments] = useState([]);
    
    const messages = model?.reportMessages || [];

    const handleMessageAttachmentsChange = ({ target: { files }}) => {
        const maxFileSize = 10000000;
        const maxfiles = 10;
        let acceptedFiles = [...attachments];
        let rejectedFiles = [];

        for (let i = 0; i < files.length; i++) {
            let file = files[i];

            if (acceptedFiles.length === maxfiles) {
                file.reason = t('common:maxFilesAmountReached');
                rejectedFiles.push(file);
                continue;
            }

            if (file.size > maxFileSize) {
                file.reason = t('common:fileTooLarge');
                rejectedFiles.push(file);
                continue;
            }

            acceptedFiles.push(file);
        }

        setAttachments(acceptedFiles);

        if (rejectedFiles.length) {
            const rejectedMessages = rejectedFiles.map(file => `${file.name}: ${file.reason}`).join('\n');
            alert(`${t('complaint:followingFilesWereRejected')}\n${rejectedMessages}`);
        }
    }
    
    const handleRemoveAttachment = (forRemove) => {
        setAttachments([...attachments.filter((attachment) => attachment !== forRemove)]);
    }

    const handleSendNewMessage = async () => {
        if (onSendMessage) {
            const success = await onSendMessage(newMessage, attachments);
            if (success) {
                setNewMessage('');
                setAttachments([]);
                if(onUpdate) {
                    await onUpdate();
                }
            }
        }
    };
    
    const handleDeleteMessage = async (messageId) => {
        if (onMessageDelete) {
            await onMessageDelete(messageId);
        }
    }

    return (
        <div className="fk-complain-messages">
            <hr style={{marginTop: '30px'}}/>
            <h3 className="complain-messages-title">{t('formTitle')} [{messages.length}]</h3>

            <Grid container spacing={2} className="fk-form">
                <Grid item md={1} className="fk-label">
                    <label>
                        {t('answerLabel')}
                    </label>
                </Grid>
                <Grid item md={8}>
                    <div className="fk-input--with-counter">
                        <textarea className="fk-input fk-input--full-width"
                            placeholder={t('answerPlaceholder')}
                            value={newMessage}
                            onChange={(event) => setNewMessage(event.target.value)}
                            rows={5}
                            maxLength={8000}
                        />
                        <div className="fk-word-counter">
                            {t('charsLimit')} {newMessage.length} / 8000
                        </div>
                    </div>
                </Grid>
                <Grid item md={3}>
                    <div className="fk-complain-send-message-buttons">
                        <IconButton
                            className="message-attachments-upload"
                            aria-label="upload"
                            component="label"
                        >
                            <input hidden accept="*" type="file" multiple onChange={handleMessageAttachmentsChange}/>
                            <AttachFile />
                        </IconButton>
                        <Button
                            fullWidth
                            className="fk-button fk-button--medium fk-button--full-width fk-button--primary"
                            onClick={handleSendNewMessage}
                        >
                            {t('sendMessageButton')}
                        </Button>
                    </div>
                </Grid>
                <Grid item md={1} />
                <Grid item md={11} className="helper-text">
                    {attachments.length > 0 &&
                        <ul className="fk-message-files-list --flex-start">
                            <li>
                                {t('choosenFiles')}
                            </li>
                            {attachments.map((attachment, index) => (
                                <li key={index}>
                                    {attachment.name}
                                    <button onClick={() => handleRemoveAttachment(attachment)}>
                                        <img src={TrashIcon} alt="" />
                                    </button>
                                </li>
                            ))}
                        </ul>
                    }
                    {t('beforeMessageSendWarning')}
                </Grid>
            </Grid>
            {messages?.map((message) => (
                <ComplainMessage key={message.id} data={message} onDelete={() => handleDeleteMessage(message.id)} />
            ))}
        </div>
    );
}

export default ComplainMessages;
